
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import AppSelectSaleLayout from "@/components/SelectSaleLayout.vue";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { PrintContext } from "@/utils/sale-layouts/print-settings";
import Vue from "vue";
import AppDefaultSettings from "./SaleEditSaveModalDefaultSettings.vue";
import AppTotalBox from "./SaleEditSaveModalTotalBox.vue";

export default Vue.extend({
	data() {
		return {
			preventClose: false,
			loading: false
		};
	},
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	computed: {
		isSaving():boolean {
			return this.state.isSaving;
		},
		printContextPrint():PrintContext {
			return PrintContext.PRINT;
		},
		printContextDownload():PrintContext {
			return PrintContext.DOWNLOAD;
		},
		printContextSend():PrintContext{
			return PrintContext.EMAIL_SEND;
		}
	},
	methods: {
		async save() {
			try {
				await this.state.save();
				this.$wf.notify(this.$t("common.success").toString(), "success", 3000, "check");
				await this.$nextTick();
				if (!this.preventClose) this.state.onFinish();
			} catch(err) {
				console.log(err);
			}
			this.preventClose = false;
		},

		async send() {
			this.preventClose = true;
			this.loading = true;
			try {
				await this.state.openSendModal();
				this.state.onFinish();
			} catch(err) {
				console.log(err);
			}
			this.loading = false;
		},

		async download() {
			this.preventClose = true;
			this.loading = true;
			try {
				await this.state.download();
				this.state.onFinish();
			} catch (err) {
				console.log(err);
			}
			this.loading = false;
			return;
		},

		async print() {
			this.preventClose = true;
			this.loading = true;
			try {
				await this.state.print();
			} catch(err) {
				console.log(err);
			}
			this.loading = false;
			this.preventClose = false;
		},


	},
	components: {
		AppDefaultSettings,
		AppCustomLanguageSelect,
		AppSelectSaleLayout,
		AppTotalBox
	}
});
